import {Injectable, Injector} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '@abstract/api.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {ErrorLoggerService} from '@services/error-logger.service';
import {Observable} from 'rxjs';
import {EventsService} from '@services/events.service';

/**
 * Допуск к URL разрешен только если в URL есть токен в качестве параметра, например
 * http://path/to/page?code=3DcRT0NjMWM4--M%3D75AEfjDDi9vPBNbr9vN_1537254987
 *
 * Проверяется код активации и, если профиль теперь корректно активирован, показывается уведомление.
 * Но в любом случае редиректим на главную страницу.
 * */

@Injectable()
export class ActivationGuardService extends ApiService implements CanActivate {
    baseUrl = 'user/activate';

    constructor(
        http: HttpClient,
        logger: ErrorLoggerService,
        injector: Injector,
        private events: EventsService,
        private router: Router,
    ) {
        super(http, logger, injector);
    }

    /**
     * Данный Guard всегда будет запрещать доступ по роуту, так как компонента там нет.
     * Guard нужен чтобы активировать профиль и отправить человека в корень приложения
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<boolean>}
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const code = route.queryParams && route.queryParams.code ? route.queryParams.code : null;

        if (!code) {
            this.router.navigate(['/']);
            return of(false);
        }

        return this.get({
            id: code,
        }).pipe(
            // status == true
            map(() => {
                /**
                 * На этапе проверки Noty еще не работает по какой-то причине, поэтому через таймаут запускаем уведомление
                 */
                this.events.notyShow$.next({
                    type: 'success',
                    content: 'Ваша учетная запись успешно активирована'
                });
                this.router.navigate(['/']);
                return false;
            }),
            // status == false or another error
            catchError((error) => {
                this.router.navigate(['/']);
                return of(false);
            })
        );
    }
}
